import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { CheckoutState } from '../../+state/checkout.reducer';

export const mockCheckoutState: CheckoutState = {
  completedItems: [],
  customerDetails: mockCustomerDetails,
  purchasing: false,
};
